<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-04-27 15:51:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-28 16:19:50
-->

<script lang="ts" setup>
import { DeleteOutlined } from '@ant-design/icons-vue';
import type { FileItem } from '../types';

interface IDataSource {
  dataSource: FileItem[];
}

withDefaults(defineProps<IDataSource>(), {
  dataSource: () => [],
});

const emit = defineEmits(['handleRemove']);

function calculator1024(size: number) {
  return parseFloat((size / 1024).toFixed(2));
}

// 删除
function handleRemove(record: FileItem) {
  emit('handleRemove', record);
}
</script>

<template>
  <table class="my-table">
    <thead>
      <tr>
        <th>文件名</th>
        <!-- <th>状态</th> -->
        <th>大小</th>
        <th>操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, i) in dataSource" :key="i">
        <td>{{ item.name }}</td>
        <!-- <td>{{ item.status }}</td> -->
        <td>
          {{
            calculator1024(item.size) <= 1024
              ? `${calculator1024(item.size)}kb`
              : `${(calculator1024(item.size) / 1024).toFixed(2)}mb`
          }}
        </td>
        <td>
          <a @click="handleRemove(item)">
            <DeleteOutlined style="color: red" />
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="less" scoped>
.my-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}

.my-table th,
.my-table td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.my-table th {
  background-color: #fafafa;
}
</style>
